/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Frustrating_RememberingInputs */

const en_onboarding_frustrating_remembering = /** @type {(inputs: Onboarding_Frustrating_RememberingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remembering what I read`)
};

const es_onboarding_frustrating_remembering = /** @type {(inputs: Onboarding_Frustrating_RememberingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recordar lo que leí`)
};

/**
* | output |
* | --- |
* | "Remembering what I read" |
*
* @param {Onboarding_Frustrating_RememberingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_frustrating_remembering = /** @type {((inputs?: Onboarding_Frustrating_RememberingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Frustrating_RememberingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_frustrating_remembering(inputs)
	return en_onboarding_frustrating_remembering(inputs)
});